import React from 'react';
import { User, users } from '../types';
import './UserSelector.css';

interface UserSelectorProps {
  selectedUser: User;
  onUserChange: (user: User) => void;
}

const UserSelector: React.FC<UserSelectorProps> = ({ selectedUser, onUserChange }) => {
  return (
    <div className="user-selector-container">
      <h2 className="user-selector-title">👤 Kullanıcı Seçin</h2>
      <div className="user-cards">
        {users.map((user) => (
          <div
            key={user.id}
            className={`user-card ${selectedUser.id === user.id ? 'active' : ''}`}
            onClick={() => onUserChange(user)}
          >
            <div className="user-avatar">
              {user.displayName.split(' ').map(name => name[0]).join('')}
            </div>
            <div className="user-info">
              <h3 className="user-name">{user.displayName}</h3>
              <p className="user-id">@{user.name}</p>
            </div>
            {selectedUser.id === user.id && (
              <div className="active-indicator">
                ✓
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default UserSelector;
